import Modal from "react-bootstrap/Modal";
import React, { useState, useEffect, useMemo, useRef } from "react";
import axios from "axios";
import "../../Style/Checkbox.scss";
import { errorAlert, handleSuccess, getApiErrorMessage } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import "../../Style/__button.scss";
import AddBoxIcon from "@mui/icons-material/AddBox";
import "./ClientsModal.scss";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "react-select";
import { AddElementsButton } from "../../Components/AddElementsButton";
import InputAdornment from "@mui/material/InputAdornment";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import Tooltip from "@mui/material/Tooltip";

function InsertClients(props) {
  const headers = authHeader();
  const isEditMode = props.mode === "edit";
  const normalizeBankAccount = (value = "") =>
    value.replace(/\D/g, "");
  const formatBankAccount = (value = "") =>
    normalizeBankAccount(value).replace(/(.{4})/g, "$1 ").trim();
  const [data, setData] = useState([]);
  const [findIdentificationNr, setFindIdentificationNr] = useState("");
  const [idNumberExist, setIDNumberExist] = useState(false);
  const [accountID, setAccountID] = useState(null);

  const [AccName, setAccName] = useState("");
  const [IdNumber, setIdNumber] = useState("");
  const [vatNumber, setVatNumber] = useState("");
  const [adress, setAdress] = useState("");
  const [cityID, setCityID] = useState("");

  const [bankID, setBankID] = useState();
  const [bankAccount, setBankAccount] = useState("");
  const [accEmail, setAccEmail] = useState("");
  const [comment, setComment] = useState("");
  const [phone, setPhone] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const initialSnapshotRef = useRef(null);
  const [showConfirmClose, setShowConfirmClose] = useState(false);

  const [stateid, setStateID] = useState("");

  const [states, setStates] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);

  const [city, setCity] = useState([]);
  const [filteredCity, setFilteredCity] = useState([]);

  const [bank, setBank] = useState([]);
  const [filteredBank, setFilteredBank] = useState([]);

  const [stateError, setStateError] = useState("");
  const [cityError, setCityError] = useState("");
  const [accNameError, setAccNameError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [idNumberEror, setIdNumberError] = useState("");
  const [vatError, setVatError] = useState("");
  const [bankAccountError, setBankAccountError] = useState("");

  const [clientType, setClientType] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [stateName, setStateName] = useState("");
  const [cityName, setCityName] = useState("");
  const [bankName, setBankName] = useState("");

  const resetForm = () => {
    setAccountID(null);
    setAccName("");
    setIdNumber("");
    setVatNumber("");
    setAdress("");
    setCityID("");
    setStateID("");
    setBankID(undefined);
    setBankAccount("");
    setAccEmail("");
    setComment("");
    setPhone("");
    setIsActive(true);
    setStateName("");
    setCityName("");
    setBankName("");
    setClientType("");
    setStateError("");
    setCityError("");
    setAccNameError("");
    setAddressError("");
    setIdNumberError("");
    setVatError("");
    setBankAccountError("");
    setFindIdentificationNr("");
    setIDNumberExist(false);
    setIsSubmitting(false);
    initialSnapshotRef.current = null;
    setShowConfirmClose(false);
  };

  const setFormFromClient = (client) => {
    const formattedBankAccount = formatBankAccount(client?.BankAccount ?? "");

    setAccountID(client?.AccountID ?? null);
    setAccName(client?.AccountName ?? "");
    setIdNumber(client?.IdentificationNumber ?? "");
    setFindIdentificationNr(client?.IdentificationNumber ?? "");
    setVatNumber(client?.VATNumber ?? "");
    setAdress(client?.Adress ?? "");
    setStateID(client?.StateID ?? "");
    setCityID(client?.CityID ?? "");
    setBankID(client?.BankID ?? undefined);
    setBankAccount(formattedBankAccount);
    setAccEmail(client?.Email ?? "");
    setComment(client?.Comment ?? "");
    setPhone(client?.PhoneNumbers ?? "");
    setIsActive(typeof client?.IsActive === "boolean" ? client.IsActive : true);
    setStateName(client?.StateName ?? "");
    setCityName(client?.CityName ?? "");
    setBankName(client?.BankName ?? "");
    setStateError("");
    setCityError("");
    setAccNameError("");
    setAddressError("");
    setIdNumberError("");
    setVatError("");
    setBankAccountError("");
    initialSnapshotRef.current = {
      AccName: client?.AccountName ?? "",
      IdNumber: client?.IdentificationNumber ?? "",
      vatNumber: client?.VATNumber ?? "",
      adress: client?.Adress ?? "",
      stateid: client?.StateID ?? "",
      cityID: client?.CityID ?? "",
      bankID: client?.BankID ?? undefined,
      bankAccount: formattedBankAccount,
      accEmail: client?.Email ?? "",
      comment: client?.Comment ?? "",
      phone: client?.PhoneNumbers ?? "",
      isActive: typeof client?.IsActive === "boolean" ? client.IsActive : true,
    };
  };

  // getApiErrorMessage is imported from Alerts.js

  const handleSubmit = (event) => {
    event.preventDefault();
    if (isSubmitting) {
      return;
    }

    let hasValidationError = false;
    const normalizedBankAccount = normalizeBankAccount(bankAccount);

    if (AccName.trim() === "") {
      setAccNameError("Plotësoni emrin e klientit");
      hasValidationError = true;
    } else {
      setAccNameError("");
    }

    if (adress.trim() === "") {
      setAddressError("Plotësoni adresën");
      hasValidationError = true;
    } else {
      setAddressError("");
    }

    if (IdNumber == null || IdNumber === "") {
      setIdNumberError("Plotësoni numrin identifikues");
      hasValidationError = true;
    }

    if (IdNumber.length > 15) {
      setIdNumberError(
        "Numri identifikues nuk duhet te ketë më shumë se 15 karaktere",
      );
      hasValidationError = true;
    }

    if (IdNumber.length === 10) {
      setClientType("Person Fizik");
    } else if (IdNumber.length === 9 && IdNumber.startsWith("6")) {
      setClientType("Organizatë");
    } else if (IdNumber.length === 9 && IdNumber.startsWith("8")) {
      setClientType("Kompani");
    } else {
      setIdNumberError("");
      setClientType("");
    }

    if (idNumberExist) {
      setIdNumberError("Klienti me kete numer identifikues ekziston");
      hasValidationError = true;
    }

    if (vatNumber.length > 15) {
      setVatError("Numri i TVSH nuk duhet te ketë më shumë se 15 karaktere");
      hasValidationError = true;
    } else {
      setVatError("");
    }

    if (normalizedBankAccount !== "") {
      const isBankAccountValid = normalizedBankAccount.length === 16;

      if (!isBankAccountValid) {
        setBankAccountError(
          "Llogaria bankare duhet të jetë fiks 16 shifra",
        );
        hasValidationError = true;
      } else {
        setBankAccountError("");
      }
    } else {
      setBankAccountError("");
    }

    if (stateid == null || stateid === "") {
      setStateError("Përzgjedh shtetin");
      hasValidationError = true;
    } else {
      setStateError("");
    }

    if (cityID == null || cityID === "") {
      setCityError("Përzgjedh qytetin");
      hasValidationError = true;
    } else {
      setCityError("");
    }

    if (hasValidationError) {
      return;
    }

    setIdNumberError("");
    setIsSubmitting(true);

    const payload = {
      AccountName: AccName,
      LedgerID: 105,
      IdentificationNumber: IdNumber,
      VATNumber: vatNumber,
      Adress: adress,
      CityID: cityID,
      StateID: stateid,
      BankID: bankID,
      BankAccount: normalizedBankAccount,
      Email: accEmail,
      Comment: comment,
      PhoneNumbers: phone,
      IsActive: isActive,
      ...(isEditMode
        ? {
            AccountID: accountID,
          }
        : {}),
    };

    const submitRequest = isEditMode
      ? axios.put(ApiLink.API_URL + "Accounts/updateAccount", payload, { headers })
      : axios.post(ApiLink.API_URL + "Accounts/insertAccount", payload, { headers });

    submitRequest
      .then(() => {
        handleSuccess(isEditMode ? "Klienti u përditësua me sukses" : "Klienti u shtua me sukses");
        resetForm();
        props.onHide();
        props.refreshData();
      })
      .catch((error) => {
        console.error(error);
        if (error.response && error.response.status === 409) {
          errorAlert(error.response.data);
        } else {
          errorAlert("An unknown error occurred while processing the request.");
        }
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  useEffect(() => {
    axios
      .get(ApiLink.API_URL + "states", { headers })
      .then((response) => {
        setStates(response.data);
      })
      .catch((error) => {
        console.error(error);
        errorAlert(getApiErrorMessage(error, "Gabim i panjohur në marrjen e shteteve."));
      });
  }, []);

  useEffect(() => {
    if (!props.show) {
      return;
    }

    if (isEditMode) {
      if (!props.initialData) {
        return;
      }

      setFormFromClient(props.initialData);
      if (props.initialData.StateID) {
        fetchCityByState(props.initialData.StateID);
      }
      return;
    }

    resetForm();
  }, [props.show, isEditMode, props.initialData]);

  const fetchCityByState = async (selectedStateID) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Cities/getcitybystate",
        { headers, params: { stateid: selectedStateID } },
      );
      setCity(response.data);
    } catch (error) {
      errorAlert(getApiErrorMessage(error, "Gabim i panjohur në kërkesë. Shih konsolën për detaje."));
    }
  };

  const isDirty = useMemo(() => {
    if (!isEditMode) {
      return (
        AccName.trim() !== "" ||
        IdNumber !== "" ||
        vatNumber !== "" ||
        adress.trim() !== "" ||
        stateid !== "" ||
        cityID !== "" ||
        bankID != null ||
        bankAccount !== "" ||
        accEmail !== "" ||
        comment !== "" ||
        phone !== ""
      );
    }
    const snap = initialSnapshotRef.current;
    if (!snap) return false;
    return (
      AccName !== snap.AccName ||
      IdNumber !== snap.IdNumber ||
      vatNumber !== snap.vatNumber ||
      adress !== snap.adress ||
      stateid !== snap.stateid ||
      cityID !== snap.cityID ||
      bankID !== snap.bankID ||
      bankAccount !== snap.bankAccount ||
      accEmail !== snap.accEmail ||
      comment !== snap.comment ||
      phone !== snap.phone ||
      isActive !== snap.isActive
    );
  }, [isEditMode, AccName, IdNumber, vatNumber, adress, stateid, cityID,
    bankID, bankAccount, accEmail, comment, phone, isActive]);

  const doClose = () => {
    props.onHide();
    resetForm();
  };

  const handleClose = () => {
    if (isDirty) {
      setShowConfirmClose(true);
      return;
    }
    doClose();
  };

  useEffect(() => {
    axios
      .get(ApiLink.API_URL + "LicencedBanks", { headers })
      .then((response) => {
        setBank(response.data);
      })
      .catch((error) => {
        errorAlert(getApiErrorMessage(error, "Gabim i panjohur në marrjen e bankave."));
      });
  }, []);

  useEffect(() => {
    setFilteredStates(
      states.filter((item) =>
        item.StateName.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [searchTerm, states]);

  useEffect(() => {
    setFilteredCity(
      city.filter((item) =>
        item.CityName.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [searchTerm, city]);

  useEffect(() => {
    setFilteredBank(
      bank.filter((item) =>
        item.BankName.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [searchTerm, bank]);

  const handleInputChange = (newValue) => {
    const inputValue = newValue.replace(/\W/g, "");
    setSearchTerm(inputValue);
  };

  const handleFilterState = (selectedOption) => {
    if (selectedOption && selectedOption.StateID) {
      setStateID(selectedOption.StateID);
      setCityID("");
      setCityName("");
      setCity([]);
      fetchCityByState(selectedOption.StateID);
      setStateName(selectedOption.label);
      setStateError("");
      setCityError("");
    } else {
      setStateID("");
      setStateName("");
      setCityID("");
      setCityName("");
      setCity([]);
    }
  };

  const handleFilterCity = (selectedOption) => {
    if (selectedOption && selectedOption.CityID) {
      setCityID(selectedOption.CityID);
      setCityName(selectedOption.label);
      setCityError("");
    } else {
      setCityID("");
      setCityName("");
    }
  };

  const handleFilterBank = (selectedOption) => {
    if (!selectedOption) {
      setBankID(undefined);
      setBankName("");
      setBankAccount("");
      setBankAccountError("");
      return;
    }

    if (selectedOption.BankID !== bankID) {
      setBankAccount("");
      setBankAccountError("");
    }

    setBankID(selectedOption.BankID);
    setBankName(selectedOption.label);
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/accountByLedger",
        { headers, params: { ledger: 105 } },
      );
      setData(response.data);
    } catch (error) {
      errorAlert(getApiErrorMessage(error, "Gabim i panjohur në kërkesë. Shih konsolën për detaje."));
    }
  };

  const generateNUI = () => {
    const d = new Date();
    const year = String(d.getFullYear()).slice(2);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const random = Math.floor(1000 + Math.random() * 9000);
    setIdNumber(`RND${year}${month}${day}${random}`);
  };

  const checkIdNumber = () => {
    const filteredData = data.filter((item) => {
      return (
        item.IdentificationNumber &&
        item.IdentificationNumber.includes(findIdentificationNr) &&
        !["1", "8"].includes(findIdentificationNr)
      );
    });

    const hasDuplicate = filteredData.some((item) => {
      if (item.IdentificationNumber !== IdNumber) {
        return false;
      }

      if (isEditMode && accountID != null) {
        return item.AccountID !== accountID;
      }

      return true;
    });

    if (hasDuplicate) {
      setIdNumberError("Klienti me kete numer identifikues ekziston");
      setIDNumberExist(true);
    } else {
      setIdNumberError("");
      setIDNumberExist(false);
    }
  };

  useEffect(() => {
    const id = IdNumber.trim();
    if (id.length > 15) {
      setIdNumberError("Identification number must be between 0-15 numbers");
      return;
    }
    setIdNumberError("");

    if (id.length === 10) {
      setClientType(
        "Ky është një numër personal identifikues për një person fizik",
      );
    } else if (id.length === 9 && id.startsWith("6")) {
      setClientType("Ky numër i përket një organizate");
    } else if (id.length === 9 && id.startsWith("8")) {
      setClientType(
        "Ky numër i përket një kompanie të regjistruar për veprimtari biznesi",
      );
    } else {
      setClientType("");
    }
  }, [IdNumber]);

  useEffect(() => {
    checkIdNumber();
  }, [IdNumber, findIdentificationNr, data, isEditMode, accountID]);

  useEffect(() => {
    if (!stateid || stateName) {
      return;
    }

    const match = states.find((item) => item.StateID === stateid);
    if (match) {
      setStateName(match.StateName);
    }
  }, [stateid, stateName, states]);

  useEffect(() => {
    if (!cityID || cityName) {
      return;
    }

    const match = city.find((item) => item.CityID === cityID);
    if (match) {
      setCityName(match.CityName);
    }
  }, [cityID, cityName, city]);

  useEffect(() => {
    if (bankID == null || bankName) {
      return;
    }

    const match = bank.find((item) => item.BankID === bankID);
    if (match) {
      setBankName(match.BankName);
    }
  }, [bankID, bankName, bank]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
    <Modal
      {...props}
      onHide={handleClose}
      size="lg"
      dialogClassName="clients-modal-dialog"
      contentClassName="clients-modal-content"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="clients-modal-header">
        <div className="clients-modal-header-content">
          <Modal.Title id="contained-modal-title-vcenter" className="clients-modal-title">
            {isEditMode ? "Përditëso të dhënat e klientit" : "Krijo një klient të ri"}
          </Modal.Title>
          <p className="clients-modal-subtitle">
            {isEditMode
              ? "Ndrysho të dhënat e klientit dhe ruaji për përditësim në sistem."
              : "Plotësoni të dhënat e klientit dhe ruani për ta shtuar në sistem."}
          </p>
          <div className="clients-modal-meta">
            <span className="clients-meta-pill">Fushat me * janë obligative</span>
            <span className="clients-meta-pill clients-meta-pill-soft">
              Numri Identifikues: max 15 karaktere
            </span>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body className="clients-modal-body">
        <form onSubmit={handleSubmit} className="clients-form">
          <section className="clients-section">
            <h6 className="clients-section-title">Informata Kryesore</h6>
            <div className="clients-grid clients-grid-2">
              <div className="clients-field clients-field-full">
                <TextField
                  fullWidth
                  required
                  id="AccountName"
                  label="Emri i Klientit *"
                  variant="outlined"
                  type="text"
                  name="AccountName"
                  value={AccName}
                  onChange={(event) => {
                    setAccName(event.target.value);
                    if (accNameError) {
                      setAccNameError("");
                    }
                  }}
                  autoComplete="off"
                  size="small"
                />
                <span className="clients-error">{accNameError && `${accNameError}`}</span>
              </div>

              <div className="clients-field">
                <TextField
                  fullWidth
                  id="IdentificationNumber"
                  label="Numri Identifikues"
                  variant="outlined"
                  type="text"
                  name="IdentificationNumber"
                  value={IdNumber}
                  onChange={(event) => {
                    setIdNumber(event.target.value);
                    setFindIdentificationNr(event.target.value);
                    if (idNumberEror) {
                      setIdNumberError("");
                    }
                  }}
                  inputProps={{ maxLength: 15 }}
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title="Gjenero random numër" placement="right">
                          <AutorenewIcon onClick={generateNUI} className="clients-generate-icon" />
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
                <div className="clients-helper-row">
                  <span className={idNumberEror ? "clients-error" : "clients-success"}>
                    {idNumberEror || clientType}
                  </span>
                  <span className={`clients-counter ${IdNumber.length > 13 ? "clients-counter-warning" : ""}`}>
                    {IdNumber.length}/15
                  </span>
                </div>
              </div>

              <div className="clients-field">
                <TextField
                  fullWidth
                  id="VATNumber"
                  label="Numri i TVSH-së"
                  variant="outlined"
                  type="text"
                  name="VATNumber"
                  value={vatNumber}
                  onChange={(event) => {
                    setVatNumber(event.target.value);
                    if (vatError) {
                      setVatError("");
                    }
                  }}
                  inputProps={{ maxLength: 15 }}
                  autoComplete="off"
                  size="small"
                />
                <div className="clients-helper-row">
                  <span className="clients-error">{vatError && `${vatError}`}</span>
                  <span className={`clients-counter ${vatNumber.length > 13 ? "clients-counter-warning" : ""}`}>
                    {vatNumber.length}/15
                  </span>
                </div>
              </div>

              <div className="clients-field clients-field-full">
                <TextField
                  fullWidth
                  required
                  id="Adress"
                  label="Adresa *"
                  variant="outlined"
                  type="text"
                  name="Adress"
                  value={adress}
                  onChange={(event) => {
                    setAdress(event.target.value);
                    if (addressError) {
                      setAddressError("");
                    }
                  }}
                  autoComplete="off"
                  size="small"
                />
                <span className="clients-error">{addressError && `${addressError}`}</span>
              </div>

              <div className="clients-field">
                <label className="clients-select-label">Përzgjedh Shtetin *</label>
                <Select
                  inputId="StateID"
                  classNamePrefix="clients-select"
                  value={stateid ? { label: stateName, value: stateid, StateID: stateid } : null}
                  options={filteredStates.map((item) => ({
                    label: item.StateName,
                    value: item.StateID,
                    StateID: item.StateID,
                  }))}
                  onInputChange={handleInputChange}
                  onChange={handleFilterState}
                  isClearable
                  placeholder="Select"
                  noOptionsMessage={() => "No matching"}
                  components={{ IndicatorSeparator: () => null }}
                />
                <span className="clients-error">{stateError && `${stateError}`}</span>
              </div>

              <div className="clients-field">
                <label className="clients-select-label">Përzgjedh Qytetin *</label>
                <Select
                  inputId="CityID"
                  classNamePrefix="clients-select"
                  value={cityID ? { label: cityName, value: cityID, CityID: cityID } : null}
                  options={filteredCity.map((item) => ({
                    label: item.CityName,
                    value: item.CityID,
                    CityID: item.CityID,
                  }))}
                  onInputChange={handleInputChange}
                  onChange={handleFilterCity}
                  isClearable
                  placeholder="Select"
                  noOptionsMessage={() => "No matching"}
                  components={{ IndicatorSeparator: () => null }}
                />
                <span className="clients-error">{cityError && `${cityError}`}</span>
              </div>
            </div>
          </section>

          <section className="clients-section">
            <h6 className="clients-section-title">Detaje Financiare</h6>
            <div className="clients-grid clients-grid-2">
              <div className="clients-field">
                <label className="clients-select-label">Përzgjedh bankën</label>
                <Select
                  inputId="BankID"
                  classNamePrefix="clients-select"
                  value={bankID ? { label: bankName, value: bankID, BankID: bankID } : null}
                  options={filteredBank.map((item) => ({
                    label: item.BankName,
                    value: item.BankID,
                    BankID: item.BankID,
                  }))}
                  onInputChange={handleInputChange}
                  onChange={handleFilterBank}
                  isClearable
                  placeholder="Select"
                  noOptionsMessage={() => "No matching"}
                  components={{ IndicatorSeparator: () => null }}
                />
              </div>

              <div className="clients-field">
                <label className="clients-select-label">Numri i Llogarisë</label>
                <TextField
                  fullWidth
                  id="BankAccount"
                  variant="outlined"
                  type="text"
                  name="BankAccount"
                  value={bankAccount}
                  onChange={(event) => {
                    setBankAccount(formatBankAccount(event.target.value));
                    if (bankAccountError) {
                      setBankAccountError("");
                    }
                  }}
                  inputProps={{ maxLength: 19 }}
                  autoComplete="off"
                  disabled={!bankID}
                  placeholder={bankID ? "Shkruaj numrin e llogarisë" : "Fillimisht zgjidh bankën"}
                  size="small"
                />
                <span className="clients-error">
                  {bankAccountError && `${bankAccountError}`}
                </span>
              </div>
            </div>
          </section>

          <section className="clients-section">
            <h6 className="clients-section-title">Kontakt dhe Koment</h6>
            <div className="clients-grid clients-grid-2">
              <div className="clients-field">
                <TextField
                  fullWidth
                  id="Email"
                  label="Email"
                  variant="outlined"
                  type="email"
                  name="Email"
                  value={accEmail}
                  onChange={(event) => setAccEmail(event.target.value)}
                  autoComplete="off"
                  size="small"
                />
              </div>

              <div className="clients-field">
                <TextField
                  fullWidth
                  id="PhoneNumber"
                  label="Numri i Telefonit"
                  variant="outlined"
                  type="tel"
                  name="PhoneNumber"
                  value={phone}
                  onChange={(event) => setPhone(event.target.value)}
                  autoComplete="off"
                  size="small"
                />
              </div>

              <div className="clients-field clients-field-full">
                <textarea
                  rows={2}
                  className="clients-notes"
                  id="Comment"
                  placeholder="Komenti"
                  name="Comment"
                  value={comment}
                  onChange={(event) => setComment(event.target.value)}
                  autoComplete="off"
                />
              </div>
            </div>
          </section>

          <div className="clients-modal-footer">
            <Button
              type="submit"
              variant="contained"
              className="clients-save-btn"
              disabled={isSubmitting || (isEditMode && !isDirty)}
            >
              {isSubmitting
                ? "Duke ruajtur..."
                : isEditMode
                  ? "Përditëso & Mbyll"
                  : "Ruaj & Mbyll"}
            </Button>
            <Button
              variant="outlined"
              className="clients-close-btn"
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Mbyll
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>

    <Dialog
      open={showConfirmClose}
      onClose={() => setShowConfirmClose(false)}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>Konfirmo mbylljen</DialogTitle>
      <DialogContent>
        Keni ndryshime të paruajtura. Nëse mbyllni tani, të dhënat e ndryshuara do të humbin. A jeni të sigurt?
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setShowConfirmClose(false)} variant="outlined">
          Kthehu
        </Button>
        <Button onClick={doClose} variant="contained" color="error">
          Po, mbyll pa ruajtur
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
}

export default function ClientsModal(props) {
  const [internalModalShow, setInternalModalShow] = React.useState(false);
  const isControlled = typeof props.show === "boolean";
  const modalShow = isControlled ? props.show : internalModalShow;

  const openModal = () => {
    if (isControlled) {
      return;
    }

    setInternalModalShow(true);
  };

  const closeModal = () => {
    if (isControlled) {
      if (props.onHide) {
        props.onHide();
      }
      return;
    }

    setInternalModalShow(false);
  };

  const handleRefreshData = () => {
    if (props.fetchData) {
      props.fetchData();
    }
  };

  return (
    <>
      {!isControlled &&
        (props.type === "text" ? (
          <AddElementsButton
            text="Krijo Klient"
            onClick={openModal}
            icon="bi bi-plus-circle"
            className="button-68"
          />
        ) : props.type === "insert" ? (
          <AddElementsButton
            text="Krijo Klient"
            onClick={openModal}
            icon="bi bi-plus-circle"
            className="button-15"
          />
        ) : props.type === "none" ? null : (
          <AddBoxIcon
            style={{ height: "30px", color: "black" }}
            onClick={openModal}
          />
        ))}

      <InsertClients
        show={modalShow}
        onHide={closeModal}
        refreshData={handleRefreshData}
        mode={props.mode}
        initialData={props.initialData}
      />
    </>
  );
}
